const SEO = () => {
  return <h1>SEO</h1>;
};
export default SEO;
